import moment from 'moment';
import 'core-js/fn/set';
const MODULE_NAME = 'rendezvenyekService';
class RendezvenyekService {
	constructor($http, environment, $q) {
		'ngInject';
		this._$http = $http;
		this._$q = $q;
		this._environment = environment;
	}
	getKategoriak(model) {
		return this._$http.get(`${this._environment.backendUrl}/do/proxy/s/rendezvenyek/kategoriak`, { params: model }).then((response) => {
			return this._$q.resolve(Object.keys(response.data.facet_counts.facet_fields.kategoriak));
		});
	}
	get(id) {
		return this._$http.get(`${this._environment.backendUrl}/do/rendezvenyek/${id}`).then((response) => {
			response.data.date = new Date(response.headers('date'));
			response.data.response.docs = response.data.response.docs.map((item) => {
				item.kezdodatum = new Date(item.kezdodatum);
				item.vegdatum = new Date(item.vegdatum);
				return item;
			});
			return this._$q.resolve(response);
		}, () => {
			return this._$q.reject();
		});
	}
	lista(model, narrow) {
		let params;
		//narrow nezetnel multbelieket nem kerdezzuk le forditott sorrendben
		if (narrow) {
			params = angular.extend({ sorrend: 'asc', multbeli: false }, model);
		} else {
			params = angular.extend({ sorrend: 'desc'}, model);
		}
		return this._$http.get(`${this._environment.backendUrl}/do/rendezvenyek/kereso`, { params }).then((response) => {
			response.data.date = new Date(response.headers('date'));
			response.data.response.docs = response.data.response.docs.map((item) => {
				item.kezdodatum = new Date(item.kezdodatum);
				item.vegdatum = new Date(item.vegdatum);
				return item;
			});
			return this._$q.resolve(response);
		}, () => {
			return this._$q.reject();
		});
	}
	_getDates(startDate, stopDate) {
		var dateArray = [];
		var currentDate = startDate;
		while (currentDate <= stopDate) {
			dateArray.push(currentDate);
			currentDate = moment(currentDate).add(1, 'days').toDate();
		}
		dateArray = [...new Set(dateArray)];
		return dateArray;
	}
	naptar() {
		return this._$http.get(`${this._environment.backendUrl}/do/rendezvenyek/naptar`).then((response) => {
			response.data.response.docs = response.data.response.docs.map((item) => {
				item.kezdodatum = new Date(item.kezdodatum);
				item.vegdatum = new Date(item.vegdatum);
				return item;
			});
			let dates = [];
			for (let doc of response.data.response.docs) {
				let dateRange = doc;
				dates = dates.concat(this._getDates(dateRange.kezdodatum, dateRange.vegdatum));
			}
			return this._$q.resolve(dates);
		}, () => {
			return this._$q.reject();
		});

	}
}

export default angular.module(MODULE_NAME, [])
	.service('rendezvenyekService', RendezvenyekService).name;



// WEBPACK FOOTER //
// ./source/applications/rendezvenyek/rendezvenyek-service.js